module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "ion-item-options"
  }, [_t("default")])
}},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2211dc4c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/item/src/item.options.vue
// module id = 153
// module chunks = 0